import { Button } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EmailVerification from 'supertokens-auth-react/recipe/emailverification';

import { ContentOverlay } from 'src/Containers/ContentOverlay';
import { useIsLoggedIn } from 'src/Hooks/Auth/useIsLoggedIn';

import styles from './PleaseConfirmEmail.module.scss';

const PleaseConfirmEmail = () => {
  const isLoggedIn = useIsLoggedIn();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  return (
    <ContentOverlay>
      <div className={styles.container}>
        <p className={styles.title}>{t('confirmEmail.confirmTitle', 'Confirmez votre compte')}</p>
        <p className={styles.description}>
          {t(
            'confirmEmail.confirmDescription',
            'Pour finaliser votre inscription, cliquez sur le lien envoyé à votre adresse email. Pensez à vérifier vos spams si nécessaire.'
          )}
        </p>

        {isLoggedIn && (
          <Button
            loading={loading}
            onClick={async () => {
              setLoading(true);

              try {
                const response = await EmailVerification.sendVerificationEmail();
                if (response.status === 'EMAIL_ALREADY_VERIFIED_ERROR') {
                  notifications.show({
                    title: t('confirmEmail.emailAlreadyVerifiedTitle', 'Déjà vérifié'),
                    message: t(
                      'confirmEmail.emailAlreadyVerified',
                      'Votre email est déjà vérifié 🌟'
                    ),
                  });
                } else if (response.status === 'OK') {
                  notifications.show({
                    title: t('confirmEmail.emailSentTitle', 'Envoyé'),
                    message: t('confirmEmail.emailSent', 'Email envoyé 🌟'),
                  });
                }

                setLoading(false);
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
              } catch (error) {
                notifications.show({
                  title: t('confirmEmail.unknownError', 'Erreur inconnue'),
                  message: t('confirmEmail.contactSupport', 'Contactez le support'),
                });
                setLoading(false);
              }
            }}
          >
            {t('confirmEmail.resend', 'Renvoyer un email de vérification')}
          </Button>
        )}
      </div>
    </ContentOverlay>
  );
};

export default PleaseConfirmEmail;
